<highcharts-chart  [Highcharts]="Highcharts" [constructorType]="chartConstructor" [(update)]="updateValue" [options]="chartOptions">
</highcharts-chart>
